<template>
    <v-app v-if="loaded" id="inspire">
        <v-snackbar
            v-model="snackbarFoundArticles"
            timeout="6000"
            multi-line
            top
            left
            color="green"
        >
            {{ $t("messages.foundArticles") }}
            {{ countOfFoundArticles() }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    icon
                    dark
                    v-bind="attrs"
                    @click="snackbarFoundArticles = !snackbarFoundArticles"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-app-bar
            v-if="screen === 'mobile'"
            app
            color="#2196F3"
            dark
            clipped-left
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <div class="fill-width align-center fill-height d-flex">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            class="d-flex align-center"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        @click="
                                            showElements.showSearch = !showElements.showSearch;
                                            showElements.showReloader = !showElements.showReloader;
                                            showElements.showSearch === false
                                                ? getInitialTree()
                                                : '';
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t("tooltips.search") }}</span>
                            </v-tooltip>
                            <v-form
                                @submit.prevent="searchSubmit"
                                class="search"
                            >
                                <div
                                    v-if="showElements.showSearch"
                                    class="d-flex align-center mr-3"
                                >
                                    <v-text-field
                                        placeholder="Поиск"
                                        class="search_input mt-3"
                                        autofocus
                                        clearable
                                        v-model="searchValue"
                                    />
                                </div>
                            </v-form>
                        </div>
                    </template>
                    <div class="date__menu-wrapper d-flex flex-wrap pa-5">
                        <v-tooltip bottom z-index="10">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    @click="
                                        showElements.showDate = !showElements.showDate
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-calendar</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="!showElements.showDate">{{
                                $t("tooltips.open_date")
                            }}</span>
                            <span v-else>{{ $t("tooltips.close_date") }}</span>
                        </v-tooltip>
                        <v-menu
                            v-model="showElements.showDateMenu"
                            transition="slide-y-transition"
                            :close-on-content-click="false"
                            offset-y
                            bottom
                        >
                            <template v-slot:activator="{ attrs, on }">
                                <v-text-field
                                    v-model="getDateRangeText"
                                    :label="$t('labels.date')"
                                    placeholder="Дата"
                                    class="date input-date"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    append-outer-icon="mdi-close"
                                    @click:append-outer="
                                        currentDate.dateRangeText =
                                            currentDate.today
                                    "
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="currentDate.dateRangeText"
                                locale="ru-RU"
                                range
                                @change="showElements.showDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                        <div class="input-div" v-if="showElements.showDate">
                            <div class="d-flex align-center">
                                <div class="time__area d-flex">
                                    <v-tooltip bottom z-index="10">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="
                                                    showElements.showTime = !showElements.showTime
                                                "
                                            >
                                                <v-icon>mdi-av-timer</v-icon>
                                            </v-btn>
                                        </template>
                                        <span v-if="!showElements.showTime">{{
                                            $t("tooltips.open_time")
                                        }}</span>
                                        <span v-else>{{
                                            $t("tooltips.close_time")
                                        }}</span>
                                    </v-tooltip>
                                    <v-text-field
                                        v-if="showElements.showTime"
                                        type="time"
                                        :label="$t('labels.time_start')"
                                        v-model="currentDate.firstTime"
                                        class="mr-2 firstTime"
                                        max-width="40px"
                                    ></v-text-field>
                                    <v-text-field
                                        v-if="showElements.showTime"
                                        max-width="40px"
                                        :label="$t('labels.time_end')"
                                        v-model="currentDate.lastTime"
                                        class="lastTime"
                                        type="time"
                                        append-outer-icon="mdi-close"
                                        @click:append-outer="
                                            (currentDate.firstTime = '00:00'),
                                                (currentDate.lastTime = '23:59')
                                        "
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                        <v-tooltip bottom z-index="10">
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    class="btn btn--fill d-flex justify-center mt-2"
                                    style="width: 100%"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="searchSubmit"
                                    dark
                                    color="#2196F3"
                                >
                                    <span>
                                        {{ $t("tooltips.search") }}
                                    </span>
                                </button>
                            </template>
                            <span>{{ $t("tooltips.search_action") }}</span>
                        </v-tooltip>
                    </div>
                </v-menu>

                <v-tooltip v-if="showElements.showReloader" bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="getInitialTree"
                        >
                            <v-icon>mdi-reload</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.reload") }}</span>
                </v-tooltip>
                <v-spacer />
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn btn--download mr-3"
                            v-bind="attrs"
                            style="display: flex; align-items: center"
                            v-on="on"
                            @click="openDownloadPopup"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#fff"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#download-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.download") }}</span>
                </v-tooltip>
                <v-select
                    :items="langs"
                    v-model="currentLang"
                    item-value="key"
                    item-text="label"
                    class="mt-2 select--lang"
                    style="max-width: 45px"
                >
                    <template slot="selection" slot-scope="{ item }">
                        <span>{{ item.key }}</span>
                    </template>
                    <template slot="item" slot-scope="{ item }">
                        <span>{{ item.key }}</span>
                    </template>
                </v-select>
            </div>
        </v-app-bar>
        <v-app-bar
            v-if="screen === 'desktop'"
            app
            color="#2196F3"
            dark
            clipped-left
        >
            <div class="fill-width align-center fill-height d-flex">
                <div class="d-flex align-center">
                    <v-select
                        :items="langs"
                        v-model="currentLang"
                        item-value="key"
                        item-text="label"
                        class="mt-2 select--lang"
                        style="max-width: 45px"
                    >
                        <template slot="selection" slot-scope="{ item }">
                            <span>{{ item.key }}</span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                            <span>{{ item.key }}</span>
                        </template>
                    </v-select>
                    <v-tooltip bottom z-index="10">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                class="ml-1"
                                @click="
                                    showElements.showSearch = !showElements.showSearch;
                                    showElements.showReloader = !showElements.showReloader;
                                    showElements.showSearch === false
                                        ? getInitialTree()
                                        : '';
                                "
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t("tooltips.search") }}</span>
                    </v-tooltip>
                    <v-form @submit.prevent="searchSubmit" class="search">
                        <div
                            v-if="showElements.showSearch"
                            class="d-flex align-center mr-1"
                        >
                            <v-text-field
                                placeholder="Поиск"
                                class="search_input mt-2"
                                autofocus
                                clearable
                                v-model="searchValue"
                            />
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <button
                                        class="btn btn--round"
                                        v-bind="attrs"
                                        v-on="on"
                                        dark
                                        color="#2196F3"
                                    >
                                        <v-icon> mdi-clipboard-search </v-icon>
                                    </button>
                                </template>
                                <span>{{ $t("tooltips.search_action") }}</span>
                            </v-tooltip>
                        </div>
                    </v-form>
                </div>
                <v-divider class="mr-1 ml-1" vertical></v-divider>
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            @click="
                                showElements.showDate = !showElements.showDate
                            "
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-calendar</v-icon>
                        </v-btn>
                    </template>
                    <span v-if="!showElements.showDate">{{
                        $t("tooltips.open_date")
                    }}</span>
                    <span v-else>{{ $t("tooltips.close_date") }}</span>
                </v-tooltip>
                <div class="input-div" v-if="showElements.showDate">
                    <div class="d-flex align-center">
                        <v-menu
                            v-model="showElements.showDateMenu"
                            transition="slide-y-transition"
                            :close-on-content-click="false"
                            offset-y
                            bottom
                        >
                            <template v-slot:activator="{ attrs, on }">
                                <v-text-field
                                    v-model="getDateRangeText"
                                    :label="$t('labels.date')"
                                    placeholder="Дата"
                                    class="mt-8 date input-date"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    append-outer-icon="mdi-close"
                                    @click:append-outer="
                                        currentDate.dateRangeText =
                                            currentDate.today
                                    "
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="currentDate.dateRangeText"
                                locale="ru-RU"
                                range
                                @change="showElements.showDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                        <v-divider class="mr-1 ml-1" vertical></v-divider>
                        <v-tooltip bottom z-index="10">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="
                                        showElements.showTime = !showElements.showTime
                                    "
                                >
                                    <v-icon>mdi-av-timer</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="!showElements.showTime">{{
                                $t("tooltips.open_time")
                            }}</span>
                            <span v-else>{{ $t("tooltips.close_time") }}</span>
                        </v-tooltip>
                        <v-text-field
                            v-if="showElements.showTime"
                            type="time"
                            :label="$t('labels.time_start')"
                            v-model="currentDate.firstTime"
                            class="mt-8 mr-1 firstTime"
                            max-width="40px"
                        ></v-text-field>
                        <v-text-field
                            v-if="showElements.showTime"
                            max-width="40px"
                            :label="$t('labels.time_end')"
                            v-model="currentDate.lastTime"
                            class="mt-8 lastTime"
                            type="time"
                            append-outer-icon="mdi-close"
                            @click:append-outer="
                                (currentDate.firstTime = '00:00'),
                                    (currentDate.lastTime = '23:59')
                            "
                        ></v-text-field>
                    </div>
                </div>

                <v-divider class="mr-1 ml-1" vertical></v-divider>
                <v-tooltip v-if="showElements.showReloader" bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="getInitialTree"
                        >
                            <v-icon>mdi-reload</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.reload") }}</span>
                </v-tooltip>
                <v-divider
                    v-if="showElements.showReloader"
                    class="mr-1 ml-1"
                    vertical
                ></v-divider>
                <v-select
                    :items="getterReportsList"
                    v-model="selectedReport"
                    return-object
                    item-value="id"
                    item-text="name"
                    class="reportsSelect"
                    background-color="rgba(255, 255, 255, 0.3)"
                >
                </v-select>
                <v-tooltip bottom z-index="10" style="margin-left: 20px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="addNewsToReport"
                        >
                            <span class="btn__icon">
                                <svg width="44" height="44" viewbox="0 0 44 44">
                                    <use
                                        xlink:href="#add-news-to-report-icon"
                                    />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.addToReport") }}</span>
                </v-tooltip>
                <v-spacer />
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn btn--download mr-1"
                            v-bind="attrs"
                            style="display: flex; align-items: center"
                            v-on="on"
                            @click="openDownloadPopup"
                        >
                            <span class="btn__text">
                                {{ $t("buttons.download") }}
                            </span>
                            <span class="btn btn--stroke btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#fff"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#download-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.download") }}</span>
                </v-tooltip>
                <v-divider class="mr-1 ml-1" vertical></v-divider>
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn pt-2 ml-1"
                            v-bind="attrs"
                            v-on="on"
                            @click="exit"
                        >
                            <span class="btn__text">
                                {{ $t("buttons.exit") }}
                            </span>
                            <span class="btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#fff"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#exit-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.exit") }}</span>
                </v-tooltip>
            </div>
        </v-app-bar>
        <v-navigation-drawer
            v-if="screen === 'mobile'"
            v-model="drawer"
            :class="{ 'expansion-is-open': panelSettings.length }"
            app
            mobile-breakpoint="1280"
            class="nav-drawer"
        >
            <v-expansion-panels v-model="panelSettings" multiple>
                <v-expansion-panel class="settings-expand">
                    <v-expansion-panel-content>
                        <div
                            class="drawer__header d-flex mt-3 ml-3"
                            style="border-bottom: 1px solid #c5c5c5"
                        >
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <button
                                        class="btn btn--stroke btn--stroke-dark"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="
                                            showElements.showProfilePopUp = true;
                                            profilesManagement.radioGroup =
                                                profiles.list[0].name;
                                            getProfileSettings();
                                        "
                                        dark
                                        color="#2196F3"
                                    >
                                        <span class="btn__icon">
                                            <svg
                                                width="27"
                                                height="23"
                                                fill="#2196F3"
                                                viewBox="0 0 27 23"
                                            >
                                                <use
                                                    xlink:href="#filter-icon"
                                                />
                                            </svg>
                                        </span>
                                    </button>
                                </template>
                                <span>{{ $t("tooltips.profile") }}</span>
                            </v-tooltip>
                            <v-select
                                v-model="profiles.current"
                                @input="setProfile"
                                :items="profiles.list"
                                item-value="name"
                                item-text="name"
                                :label="$t('labels.profile')"
                                class="ml-2 mr-3"
                                style="max-width: 105px"
                            />
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <button
                                        class="btn btn--stroke btn--stroke-dark"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="
                                            showElements.showUserSettingsPopUp = true
                                        "
                                        dark
                                        color="#2196F3"
                                    >
                                        <span class="btn__icon">
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="#2196F3"
                                            >
                                                <use xlink:href="#gear-icon" />
                                            </svg>
                                        </span>
                                    </button>
                                </template>
                                <span>{{ $t("tooltips.userSettings") }}</span>
                            </v-tooltip>
                        </div>
                    </v-expansion-panel-content>
                    <v-expansion-panel-header expand-icon="mdi-menu-down" />
                </v-expansion-panel>
            </v-expansion-panels>
            <vue-custom-scrollbar
                class="scroll-area treeview__main-scroll"
                :settings="scrollbarSettings"
            >
                <v-treeview
                    item-children="children.childs"
                    item-key="hashCode"
                    hoverable
                    open-on-click
                    transition
                    selected-color="indigo"
                    active-class="is-disabled"
                    class="treeview treeview__main"
                    :items="items"
                    :open.sync="treeviewOpenedElements"
                    activatable
                    :returnObject="true"
                >
                    <template slot="prepend" slot-scope="{ item, open }">
                        <v-icon
                            v-if="item.type == 'Subject'"
                            color="orange darken-2"
                        >
                            {{
                                open
                                    ? "mdi-folder-open-outline"
                                    : "mdi-folder-outline"
                            }}
                        </v-icon>
                        <v-icon
                            v-if="item.type == 'Root'"
                            color="green darken-2"
                        >
                            {{
                                open
                                    ? "mdi-folder-home-outline"
                                    : "mdi-folder-home-outline"
                            }}
                        </v-icon>
                        <svg
                            v-if="item.type == 'SourceType'"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                        >
                            <use xlink:href="#source-type-icon" />
                        </svg>
                        <svg
                            v-if="item.type == 'PDate'"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                        >
                            <use xlink:href="#publish-date-icon" />
                        </svg>
                        <svg
                            v-if="item.type == 'Source'"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                        >
                            <use xlink:href="#source-icon" />
                        </svg>
                        <svg
                            v-if="item.type == 'LoadDate'"
                            width="23"
                            height="24"
                            viewBox="0 0 23 24"
                        >
                            <use xlink:href="#load-date-icon" />
                        </svg>
                    </template>
                    <template slot="label" slot-scope="{ item }">
                        <div style="width: 100%; margin: -5px; padding: 5px">
                            <span
                                class="treeview__activator"
                                :data-id="item.hashCode"
                                @click="getArticlesOnClick"
                            ></span>
                            <span
                                style="pointer-events: none"
                                v-html="item.name"
                            />
                            <span
                                style="pointer-events: none"
                                v-if="item.type != 'Root'"
                                >({{ item.newsCount }})</span
                            >
                        </div>
                    </template>
                </v-treeview>
            </vue-custom-scrollbar>
            <div class="drawer__footer pr-10">
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn pt-2 ml-auto"
                            v-bind="attrs"
                            v-on="on"
                            @click="exit"
                        >
                            <span class="btn__text">
                                {{ $t("buttons.exit") }}
                            </span>
                            <span class="btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#757575"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#exit-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.exit") }}</span>
                </v-tooltip>
            </div>
        </v-navigation-drawer>
        <v-navigation-drawer
            v-if="screen === 'desktop'"
            v-model="drawer"
            app
            clipped
            mobile-breakpoint="1280"
            class="nav-drawer"
        >
            <v-toolbar dense class="links-wrap">
              <v-btn :to="{ path: '/' }" class="home-btn link-btn"
              >{{ $t("tooltips.news") }}</v-btn
              >
              <v-divider class="divider" vertical></v-divider>
              <v-btn
                  :to="{ path: '/reports' }"
                  class="report-btn link-btn"
              >
                {{ $t("tooltips.reportAndSummary") }}</v-btn
              >
            </v-toolbar>
            <v-expansion-panels v-model="panelSettings" multiple>
                <v-expansion-panel class="settings-expand">
                    <v-expansion-panel-content>
                        <div
                            class="drawer__header d-flex mt-3 ml-3"
                            style="border-bottom: 1px solid #c5c5c5"
                        >
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <button
                                        class="btn btn--stroke btn--stroke-dark"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="
                                            showElements.showProfilePopUp = true;
                                            profilesManagement.radioGroup =
                                                profiles.list[0].name;
                                            getProfileSettings();
                                        "
                                        dark
                                        color="#2196F3"
                                    >
                                        <span class="btn__icon">
                                            <svg
                                                width="27"
                                                height="23"
                                                fill="#2196F3"
                                                viewBox="0 0 27 23"
                                            >
                                                <use
                                                    xlink:href="#filter-icon"
                                                />
                                            </svg>
                                        </span>
                                    </button>
                                </template>
                                <span>{{ $t("tooltips.profile") }}</span>
                            </v-tooltip>
                            <v-select
                                v-model="profiles.current"
                                @input="setProfile"
                                :items="profiles.list"
                                item-value="name"
                                item-text="name"
                                :label="$t('labels.profile')"
                                class="ml-2 mr-3"
                                style="max-width: 105px"
                            />
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <button
                                        class="btn btn--stroke btn--stroke-dark"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="
                                            showElements.showUserSettingsPopUp = true
                                        "
                                        dark
                                        color="#2196F3"
                                    >
                                        <span class="btn__icon">
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="#2196F3"
                                            >
                                                <use xlink:href="#gear-icon" />
                                            </svg>
                                        </span>
                                    </button>
                                </template>
                                <span>{{ $t("tooltips.userSettings") }}</span>
                            </v-tooltip>
                        </div>
                    </v-expansion-panel-content>
                    <v-expansion-panel-header expand-icon="mdi-menu-down" />
                </v-expansion-panel>
            </v-expansion-panels>
            <vue-custom-scrollbar
                class="scroll-area"
                style="height: calc(100vh - 220px)"
                :settings="scrollbarSettings"
            >
                <v-treeview
                    item-children="children.childs"
                    item-key="hashCode"
                    hoverable
                    open-on-click
                    transition
                    selected-color="indigo"
                    active-class="is-disabled"
                    class="treeview treeview__main"
                    :open.sync="treeviewOpenedElements2"
                    :returnObject="true"
                    v-for="(item, key) in items"
                    :key="`key_${key}`"
                    :items="item.children.childs"
                >
                    <template slot="prepend" slot-scope="{ item, open }">
                        <v-icon
                            v-if="item.type == 'Subject'"
                            color="orange darken-2"
                        >
                            {{
                                open
                                    ? "mdi-folder-open-outline"
                                    : "mdi-folder-outline"
                            }}
                        </v-icon>
                        <v-icon
                            v-if="item.type == 'Root'"
                            color="green darken-2"
                        >
                            {{
                                open
                                    ? "mdi-folder-home-outline"
                                    : "mdi-folder-home-outline"
                            }}
                        </v-icon>
                        <svg
                            v-if="item.type == 'SourceType'"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                        >
                            <use xlink:href="#source-type-icon" />
                        </svg>
                        <svg
                            v-if="item.type == 'PDate'"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                        >
                            <use xlink:href="#publish-date-icon" />
                        </svg>
                        <svg
                            v-if="item.type == 'Source'"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                        >
                            <use xlink:href="#source-icon" />
                        </svg>
                        <svg
                            v-if="item.type == 'LoadDate'"
                            width="23"
                            height="24"
                            viewBox="0 0 23 24"
                        >
                            <use xlink:href="#load-date-icon" />
                        </svg>
                    </template>
                    <template slot="label" slot-scope="{ item }">
                        <div style="width: 100%; margin: -5px; padding: 5px">
                            <span
                                class="treeview__activator"
                                :data-id="item.hashCode"
                                style="z-index: 0"
                                @click="getArticlesOnClick"
                            ></span>
                            <span
                                style="pointer-events: none"
                                v-html="item.name"
                            />
                            <span
                                style="pointer-events: none"
                                v-if="item.type != 'Root'"
                                >({{ item.newsCount }})</span
                            >
                        </div>
                    </template>
                </v-treeview>
            </vue-custom-scrollbar>
        </v-navigation-drawer>
        <v-main>
            <v-container
                fluid
                class="d-flex justify-end fill-height pb-16"
                outlined
                tile
            >
                <v-data-table
                    :headers="
                        topicsIsActive ? tableHeadersWithTopics : tableHeaders
                    "
                    :items="news"
                    :page.sync="pagination.current"
                    item-key="id"
                    show-select
                    v-model="selectedArticles"
                    @click:row="getSingleArticle"
                    class="elevation-1 fill-height fill-width news__list"
                    :loading="loading"
                    mobile-breakpoint="991"
                    show-expand
                    :expanded.sync="tableExpandedItem.data"
                >
                    <template v-slot:item.topicNewsCount="{ item }">
                        <button
                            class="d-flex align-center topics-btn"
                            v-if="item.topicNewsCount > 0"
                            @click.stop="openTopics(item.topic.topicNews)"
                        >
                            {{ item.topicNewsCount }}
                            <i class="ml-2 mt-1 d-flex align-center"
                                ><svg
                                    width="22"
                                    height="22"
                                    fill="#fff"
                                    viewBox="0 0 22 22"
                                >
                                    <use xlink:href="#plus-icon" /></svg
                            ></i>
                        </button>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td
                            :colspan="headers.length"
                            v-if="selectedArticlesContent"
                        >
                            <v-card-title
                                class="article__title"
                                v-if="selectedArticlesContent.title"
                            >
                                <a
                                    target="_blank"
                                    :href="selectedArticlesContent.uri"
                                    v-html="formated.title"
                                />
                            </v-card-title>
                            <v-select
                                style="max-width: 82vw"
                                v-model="currCategorySelect"
                                :items="
                                    selectedArticlesContent.subjects.subject
                                "
                                @input="getCategorySelections"
                                item-text="name"
                                label="Выберите подсвечиваемый   тег"
                                item-value="name"
                                dense
                                outlined
                            ></v-select>
                            <v-card>
                                <v-card-text  v-html="formated.text + `ID: ${formated.id}`"/>
                            </v-card>
                            <div class="article__closer">
                                <v-tooltip z-index="1000" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <button
                                            v-bind="attrs"
                                            v-on="on"
                                            class="article__closer-btn"
                                            @click="closeArticle"
                                        />
                                    </template>
                                    <span>{{
                                        $t("tooltips.closeArticle")
                                    }}</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </template>
                </v-data-table>
                <transition name="fade">
                    <button
                        class="btn btn--fill mt-2"
                        v-if="
                            $store.state.download.selectedArticles.length ||
                            $store.state.download.selectedTopics.length
                        "
                        @click="cleanDownloadStore()"
                        @click.prevent="
                            showElements.showProfilePopUpRemove = true
                        "
                    >
                        <span>{{ $t("buttons.resetChecked") }}</span>
                    </button>
                </transition>
            </v-container>
        </v-main>
        <v-dialog
            v-if="showElements.showProfilePopUp"
            v-model="showElements.showProfilePopUp"
            :fullscreen="screen === 'mobile' ? true : false"
            max-width="750"
        >
            <v-card
                class="profile"
                style="min-height: 300px; position: relative; height: 100%"
            >
                <v-overlay
                    absolute
                    :opacity="0.5"
                    :value="profilesManagement.loading"
                    v-if="profilesManagement.loading"
                    z-index="100000"
                >
                    <v-progress-circular indeterminate size="100">
                        {{ $t("loading") }}
                    </v-progress-circular>
                </v-overlay>
                <v-form>
                    <v-toolbar
                        flat
                        dark
                        :class="screen === 'mobile' ? '' : 'pr-10 pl-10'"
                        color="#2196F3"
                    >
                        <span class="btn__icon mr-2">
                            <svg
                                width="27"
                                height="23"
                                fill="#fff"
                                viewBox="0 0 27 23"
                            >
                                <use xlink:href="#filter-icon" />
                            </svg>
                        </span>
                        <v-toolbar-title>
                            {{ $t("modals.profileManagement.title") }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="showElements.showProfilePopUp = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-toolbar
                        dark
                        flat
                        :class="
                            screen === 'mobile'
                                ? 'd-flex justify-space-between profiles__btns'
                                : 'pr-10 pl-10'
                        "
                        color="transparent"
                    >
                        <v-tooltip z-index="1000" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    class="btn btn--fill"
                                    :class="
                                        screen === 'mobile' ? 'mr-1' : 'mr-2'
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    @click.prevent="
                                        showElements.showProfilePopUpAdd = true
                                    "
                                >
                                    <span>{{
                                        $t("modals.profileManagement.add")
                                    }}</span>
                                </button>
                            </template>
                            <span>{{
                                $t("tooltips.addProfileManagment")
                            }}</span>
                        </v-tooltip>
                        <v-tooltip z-index="1000" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    class="btn btn--fill"
                                    :class="
                                        screen === 'mobile' ? 'mr-1' : 'mr-2'
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    @click.prevent="
                                        showElements.showProfilePopUpRemove = true
                                    "
                                >
                                    <span>{{
                                        $t("modals.profileManagement.remove")
                                    }}</span>
                                </button>
                            </template>
                            <span>{{
                                $t("tooltips.removeProfileManagment")
                            }}</span>
                        </v-tooltip>
                        <v-tooltip z-index="1000" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    class="btn btn--fill"
                                    :class="screen === 'mobile' ? '' : 'mr-2'"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click.prevent="
                                        showElements.showProfilePopUpRename = true
                                    "
                                >
                                    <span v-if="screen === 'desktop'">{{
                                        $t("modals.profileManagement.rename")
                                    }}</span>
                                    <span v-else>
                                        <svg
                                            width="11"
                                            height="13"
                                            fill="#fff"
                                            viewBox="0 0 11 13"
                                        >
                                            <use xlink:href="#basket-icon" />
                                        </svg>
                                    </span>
                                </button>
                            </template>
                            <span>{{
                                $t("tooltips.renameProfileManagment")
                            }}</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-container
                        :class="screen === 'mobile' ? '' : 'pr-15 pl-15 pt-0'"
                    >
                        <v-row>
                            <v-col class="pt-0 popup__card">
                                <v-card
                                    class="profile__card"
                                    max-height="265"
                                    min-height="265"
                                >
                                    <v-card-title
                                        class="profile__card-title pl-5"
                                    >
                                        {{
                                            $t(
                                                "modals.profileManagement.subtitle_1"
                                            )
                                        }}
                                    </v-card-title>
                                    <v-card-text
                                        :class="
                                            screen === 'mobile'
                                                ? ''
                                                : 'pl-0 pr-0'
                                        "
                                    >
                                        <vue-custom-scrollbar
                                            class="scroll-area"
                                            :settings="scrollbarSettings"
                                        >
                                            <v-radio-group
                                                class="mt-0"
                                                @change="getProfileSettings"
                                                v-model="
                                                    profilesManagement.radioGroup
                                                "
                                            >
                                                <v-radio
                                                    :class="
                                                        screen === 'mobile'
                                                            ? 'pr-5 pl-5 pt-2 pb-2'
                                                            : 'pr-5 pl-5 pt-2 pb-2'
                                                    "
                                                    v-for="btn in profiles.list"
                                                    :key="`profile_${btn.id}}`"
                                                    :label="btn.name"
                                                    :value="btn.name"
                                                >
                                                    <template v-slot:label>
                                                        <span
                                                            class="d-flex align-center"
                                                        >
                                                            <svg
                                                                width="27"
                                                                height="23"
                                                                fill="blue"
                                                                viewBox="0 0 27 23"
                                                            >
                                                                <use
                                                                    xlink:href="#filter-border-icon"
                                                                />
                                                            </svg>
                                                            <span>
                                                                {{ btn.name }}
                                                            </span>
                                                        </span>
                                                    </template>
                                                </v-radio>
                                            </v-radio-group>
                                        </vue-custom-scrollbar>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col class="pt-0 popup__card">
                                <v-card
                                    class="profile__card"
                                    max-height="265"
                                    min-height="265"
                                >
                                    <v-card-title
                                        class="profile__card-title"
                                        :class="
                                            screen === 'mobile' ? '' : 'pl-10'
                                        "
                                    >
                                        {{
                                            $t(
                                                "modals.profileManagement.subtitle_2"
                                            )
                                        }}
                                    </v-card-title>
                                    <v-card-text class="pl-0 pr-0">
                                        <vue-custom-scrollbar
                                            class="scroll-area pr-5"
                                            :settings="scrollbarSettings"
                                        >
                                            <v-treeview
                                                v-if="
                                                    profilesManagement
                                                        .profileSettings.sources
                                                "
                                                v-model="
                                                    profilesManagement.selectionsSources
                                                "
                                                hoverable
                                                item-key="ind"
                                                item-text="name"
                                                item-children="items"
                                                open-on-click
                                                transition
                                                selectable
                                                return-object
                                                :items="getProfileItemsSources"
                                            >
                                            </v-treeview>
                                            <v-treeview
                                                v-if="
                                                    profilesManagement
                                                        .profileSettings
                                                        .subjects
                                                "
                                                v-model="
                                                    profilesManagement.selectionsSubject
                                                "
                                                hoverable
                                                item-key="ind"
                                                item-name="name"
                                                item-children="items"
                                                open-on-click
                                                transition
                                                selectable
                                                return-object
                                                :items="getProfileItemsSubject"
                                            >
                                            </v-treeview>
                                        </vue-custom-scrollbar>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-tooltip z-index="1000" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    class="btn btn--fill ml-auto"
                                    v-bind="attrs"
                                    v-on="on"
                                    dark
                                    @click.prevent="setNewProfileSettings"
                                >
                                    <span>{{
                                        $t("modals.profileManagement.apply")
                                    }}</span>
                                </button>
                            </template>
                            <span>{{
                                $t("tooltips.applyProfileManagment")
                            }}</span>
                        </v-tooltip>
                    </v-container>
                </v-form>
            </v-card>
            <v-dialog
                v-model="showElements.showProfilePopUpAdd"
                max-width="500px"
                scrollable
            >
                <v-card>
                    <v-form v-model="valid" ref="addProfileForm">
                        <v-card-title>
                            {{ $t("modals.profilePopUpAdd.title") }}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                name="name"
                                v-model="profilesManagement.addProfile"
                                type="text"
                                :label="$t('labels.profilePopUpAdd')"
                                hide-details="auto"
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                color="primary"
                                text
                                type="submit"
                                :class="{ disabled: disableSend === true }"
                                @click.prevent="addProfile"
                            >
                                {{ $t("modals.profilePopUpAdd.submit") }}
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="
                                    showElements.showProfilePopUpAdd = false
                                "
                            >
                                {{ $t("modals.profilePopUpAdd.reject") }}
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="showElements.showProfilePopUpRemove"
                max-width="500px"
                scrollable
            >
                <v-card>
                    <v-form ref="removeProfileForm">
                        <v-card-title>
                            {{ $t("modals.profilePopUpRemove.title") }}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                name="name"
                                v-model="profilesManagement.removeProfile"
                                type="text"
                                :label="$t('labels.profilePopUpRemove')"
                                hide-details="auto"
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                color="primary"
                                text
                                type="submit"
                                :class="{ disabled: disableSend === true }"
                                @click.prevent="removeProfile"
                            >
                                {{ $t("modals.profilePopUpRemove.submit") }}
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="
                                    showElements.showProfilePopUpRemove = false
                                "
                            >
                                {{ $t("modals.profilePopUpRemove.reject") }}
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="showElements.showProfilePopUpRename"
                max-width="500px"
                scrollable
                class="profile"
            >
                <v-card>
                    <v-form ref="renameProfileForm">
                        <v-card-title>
                            {{ $t("modals.profilePopUpRename.title") }}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                name="name"
                                v-model="
                                    profilesManagement.renameProfile.oldName
                                "
                                type="text"
                                :label="$t('labels.profilePopUpRenameOld')"
                                hide-details="auto"
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <v-text-field
                                name="name"
                                v-model="
                                    profilesManagement.renameProfile.newName
                                "
                                type="text"
                                :label="$t('labels.profilePopUpRenameNew')"
                                hide-details="auto"
                                :rules="nameRules"
                                required
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                color="primary"
                                text
                                type="submit"
                                :class="{ disabled: disableSend === true }"
                                @click.prevent="renameProfile"
                            >
                                {{ $t("modals.profilePopUpRename.submit") }}
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="
                                    showElements.showProfilePopUpRename = false
                                "
                            >
                                {{ $t("modals.profilePopUpRename.reject") }}
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-dialog>
        <v-dialog
            v-if="showElements.showDownloadPopUp"
            v-model="showElements.showDownloadPopUp"
            :fullscreen="screen === 'mobile' ? true : false"
            max-width="750"
        >
            <download
                v-on:popup_close="showElements.showDownloadPopUp = false"
                :screen="screen"
                :scrlSet="scrollbarSettings"
            />
        </v-dialog>
        <v-dialog
            v-if="showElements.showUserSettingsPopUp"
            v-model="showElements.showUserSettingsPopUp"
            :fullscreen="screen === 'mobile' ? true : false"
            max-width="750"
        >
            <user-settings
                v-on:popup_close="showElements.showUserSettingsPopUp = false"
                v-on:reload="getInitialTree()"
                v-on:topics="changeTopicActivation"
                :screen="screen"
                :scrlSet="scrollbarSettings"
            />
        </v-dialog>
        <v-dialog
            content-class="user-settings-popup"
            v-if="showElements.showTopicsPupUp"
            v-model="showElements.showTopicsPupUp"
            fullscreen
            hide-overlay
        >
            <topics
                v-on:popup_close="showElements.showTopicsPupUp = false"
                :screen="screen"
                :data="activeTopics"
                :currNodeHash="currNodeHash"
                :searchState="searchState"
            />
        </v-dialog>
        <v-dialog
            v-if="showElements.showReportsPopup"
            content-class="reports-popup"
            v-model="showElements.showReportsPopup"
            max-width="380"
        >
            <add-to-reports-popup
                v-on:popup_close="showElements.showReportsPopup = false"
                :screen="screen"
            />
        </v-dialog>
    </v-app>
</template>
<script>
import Download from "@/components/Download";
import UserSettings from "@/components/UserSettings";
import Topics from "../components/Topics.vue";

import moment from "moment";
export default {
    name: "home",
    components: {
        Download,
        UserSettings,
        Topics,
    },
    data: () => ({
        menu: false,
        panelSettings: [0],
        topicsIsActive: true,
        scrollbarSettings: {
            suppressScrollY: false,
            suppressScrollX: false,
            wheelPropagation: false,
        },
        langs: [
            {
                key: "ru",
                label: "Русский",
            },
            {
                key: "en",
                label: "English",
            },
            {
                key: "az",
                label: "Azərbaycan",
            },
        ],
        nameRules: [
            (v) => !!v || "Введите Имя",
            (v) => v.length <= 15 || "Name must be less than 10 characters",
        ],
        valid: false,
        disableSend: false,
        tableExpandedItem: {
            isOpen: null,
            data: [],
        },
        treeviewOpenedElements: [],
        treeviewOpenedElements2: [],
        showElements: {
            showUserSettingsPopUp: false,
            showProfilePopUpAdd: false,
            showProfilePopUpRemove: false,
            showProfilePopUpRename: false,
            showProfilePopUp: false,
            showDownloadPopUp: false,
            showTopicsPupUp: false,
            showSearch: false,
            showDate: true,
            showTime: false,
            showDateMenu: false,
            showReloader: true,
            showReportsPopup: false,
        },
        currCategorySelect: "",
        selectedArticles: [],
        selectedArticlesContent: "",
        selections: {
            categories: "",
            search: "",
        },
        selectionsRange: [],
        formated: {
            text: "",
            title: "",
            id: null,
        },
        drawer: null,
        currentLang: "ru",
        drawerRight: null,
        right: false,
        left: false,
        loaded: false,
        items: [],
        profiles: {
            current: "",
            list: [],
        },
        profilesManagement: {
            radioGroup: "",
            profileSettings: "",
            loading: false,
            selectionsSubject: [],
            selectionsSources: [],
            addProfile: "",
            removeProfile: "",
            renameProfile: {
                newName: "",
                oldName: "",
            },
        },
        activeTopics: [],
        loading: false,
        page: 1,
        pageCount: 1,
        searchValue: "",
        searchState: false,
        currentDate: {
            dateRangeText: ["00.00.00", "00.00.00"],
            firstDate: "",
            lastDate: "",
            firstTime: "00:00",
            lastTime: "23:59",
            today: "",
        },
        news: [],
        currNodeHash: "0",
        currArticleId: "",
        currentProcessingNode: 0,
        screen: "",
        snackbarFoundArticles: false,
        pagination: {
            current: 0,
        },
        highlightedLine: null,
        selectedReport: "",
    }),
    props: ["source"],
    watch: {
        selectedArticles: function () {
            this.$store.commit("updateSelectedForDownload", {
                selectedArticles: this.selectedArticles,
            });
        },
        /**
         * apply highlight by chosen category selection (select in single article)
         * */
        selectedArticlesContent: function () {
            this.divideText(
                this.selectedArticlesContent.text,
                this.selectedArticlesContent.title
            );
        },
        selections: {
            handler() {
                this.divideText(
                    this.selectedArticlesContent.text,
                    this.selectedArticlesContent.title
                );
            },
            deep: true,
        },
        /**
         * apply chosen language
         * */
        currentLang: function () {
            this.$vuetify.lang.current = this.$store.state.lang = this.$i18n.locale = this.currentLang;
            localStorage.setItem("lang", this.$i18n.locale);
        },
    },
    created() {
        this.$store.commit("setWindowWidth");
        this.screen = this.$store.state.windowWidth;
    },
    async mounted() {
        
        await this.$store.dispatch("getUserSettings");
        this.$store.commit("startLoader");
        await this.$store.dispatch("GetReportNames");
        this.currentLang = this.$store.state.lang = this.$i18n.locale;
        localStorage.setItem("lang", this.$i18n.locale);
        /**
         * get initial date
         * */
        let currentDate = new Date();
        let startDate = this.$options.filters.date(
            new Date(currentDate.setDate(currentDate.getDate())),
            "DDMMYYYYhhmmss"
        );
        let endDate = this.$options.filters.date(
            new Date(currentDate),
            "DDMMYYYYhhmmss"
        );

        this.currentDate.dateRangeText = [
            endDate.split(", ")[0].split(".").reverse().join("-"),
        ];
        this.currentDate.firstDate = endDate.split(", ")[0];
        this.currentDate.lastDate = endDate.split(", ")[0];

        this.currentDate.today = this.currentDate.dateRangeText;
        /**
         * send request and get main treeview content
         * */
        this.getProfiles();
        this.selectedArticles = this.$store.getters.selectedArticles;
        this.currNodeHash = this.$store.getters.nodeHash

      // await this.$store.dispatch("GetReportNames");
    },
    computed: {
        getterReportsList() {
            return this.$store.getters.reportsList;
        },
        /**
         * transform Source items from profile settings for treeview properly work
         * */
        getProfileItemsSources() {
            return this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.sources,
            ]);
        },
        /**
         * transform Subject items from profile settings for treeview properly work
         * */
        getProfileItemsSubject() {
            return this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.subjects.items,
            ]);
        },
        /**
         * remove selectable categories, which return from server with empty select range
         * */
        selectMarkableText() {
            if (!this.selectedArticlesContent) {
                return [];
            }
            /*let res = this.selectedArticlesContent.subjects.subject.filter(item => item.selections.selection)*/
            return this.selectedArticlesContent.subjects.subject;
        },
        /**
         * initialization v-data-table headers (watch vuetify documentation)
         * */
        tableHeadersWithTopics() {
            return [
                {
                    text: this.$t("data_table.topics"),
                    value: "topicNewsCount",
                    align: "center",
                    width: "90px",
                },
                {
                    text: this.$t("data_table.title"),
                    align: "start",
                    value: "title",
                    class: "title_td",
                },
                {
                    text: this.$t("data_table.publish_date"),
                    value: "publishDate",
                    width: "150px",
                },
                {
                    text: this.$t("data_table.source"),
                    value: "source",
                    width: "200px",
                },
                /* { text: this.$t("data_table.rate"), value: "rating" }, */
                {
                    text: this.$t("data_table.relevance"),
                    value: "relevance",
                    width: "121px",
                },
            ];
        },
        tableHeaders() {
            return [
                {
                    text: this.$t("data_table.title"),
                    align: "start",
                    value: "title",
                },
                {
                    text: this.$t("data_table.publish_date"),
                    value: "publishDate",
                },
                {
                    text: this.$t("data_table.source"),
                    value: "source",
                    width: "200px",
                },
                // { text: this.$t("data_table.rate"), value: "rating" },
                { text: this.$t("data_table.relevance"), value: "relevance" },
            ];
        },
        /**
         * transform date range for further request to server
         * */
        getDateRangeText() {
            let date = this.currentDate.dateRangeText.map((item) =>
                item.split("-").reverse().join(".")
            );
            this.currentDate.firstDate = date[0];
            this.currentDate.lastDate = date[1];
            let transform = (dateBefore) => {
                if (dateBefore) {
                    return [
                        ...dateBefore.slice(0, 6),
                        ...dateBefore.slice(8, 10),
                    ].join("");
                }
                return "";
            };
            let nextDate = this.currentDate.lastDate;
            if (this.currentDate.firstDate > this.currentDate.lastDate) {
                this.currentDate.lastDate = this.currentDate.firstDate;
                this.currentDate.firstDate = nextDate;
            }
            let transformData = [
                transform(this.currentDate.firstDate),
                transform(this.currentDate.lastDate),
            ].join(" - ");
            return transformData;
            /*
            let transformData = this.currentDate.dateRangeText.map(item => item.split('-').reverse().join('.'));
            this.currentDate.firstDate = transformData[0]
            this.currentDate.lastDate = transformData[1]
            return transformData.join('-')*/
        },
    },
    methods: {
        openTreeview(arr, count){
            let q = [];
            arr.forEach(item => {
                q.push(item)
                item.children.childs.forEach(el => {
                    q.push(el)
                })
            })
            return q
        },
        addNewsToReport() {
            if (!this.selectedReport) {
                return this.$toastr.warning(this.$t("messages.selectedReport"));
            }
            if (!this.selectedArticles.length) {
                return this.$toastr.warning(this.$t("messages.selectArticles"));
            }
            let arr = this.selectedArticles.map((item) => {
                return item.id;
            });
            this.$axios
                .post(
                    "http://core.memo.az/mainwindow/AddReportDocuments",
                    {
                        reportName: this.selectedReport.name,
                        docIDs: arr,
                    }
                )
                .then((res) => {
                    this.selectedArticles = [];
                    return res.data;
                })
                .finally(() => {});
        },
        openReportsPopup() {
            if (
                this.$store.state.download.selectedArticles.length ||
                this.$store.state.download.selectedTopics.length
            ) {
                return (this.showElements.showReportsPopup = true);
            }
            this.$toastr.warning(this.$t("messages.selectArticles"));
        },
        /**
         * anable topic column in data-table
         * */
        changeTopicActivation(isActive) {
            isActive
                ? (this.topicsIsActive = true)
                : (this.topicsIsActive = false);
        },
        openDownloadPopup() {
            if (
                this.$store.state.download.selectedArticles.length ||
                this.$store.state.download.selectedTopics.length
            ) {
                return (this.showElements.showDownloadPopUp = true);
            }
            this.$toastr.warning(this.$t("messages.selectArticles"));
        },
        /**
         * transform data which return from profile settings request
         * */
        formatKeyInObg(object, prev_key, next_key, name_key_value) {
            const RENAME_KEY = (obj, old_key, new_key) => {
                if (obj[old_key]) {
                    Object.defineProperty(
                        obj,
                        new_key,
                        Object.getOwnPropertyDescriptor(obj, old_key)
                    );
                    delete obj[old_key];
                }
                return obj;
            };
            object.name = name_key_value;
            object.id = `${name_key_value}_1`;
            return RENAME_KEY(object, prev_key, next_key);
        },
        /**
         * exit btn action
         * */
        exit() {
            localStorage.removeItem("hash");
            this.$router.push("/login");
        },
        /**
         * transform time from 00:00 format to 00:00:00 for request
         * */
        transformTime(time) {
            let tempTime;
            tempTime = time.split(":").concat(["00"]).join(":");
            return tempTime;
        },
        /**
         * clean all selected topics or news
         * */
        cleanDownloadStore() {
            this.$store.commit("updateSelectedForDownload", {
                selectedArticles: [],
                selectedTopics: [],
            });
            this.selectedArticles = [];
        },
        /**
         * validate search date range
         * */
        dateValidation() {
            let start;
            let end;
            const DATE_FORMAT = (date) => {
                return date;
            };
            if (this.currentDate.dateRangeText.length === 1) {
                if (
                    this.showElements.showTime &&
                    this.currentDate.firstTime &&
                    this.currentDate.lastTime
                ) {
                    start = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, ${this.transformTime(this.currentDate.firstTime)}`;
                    end = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, ${this.transformTime(this.currentDate.lastTime)}`;
                    return [start, end];
                } else {
                    start = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, 00:00:00`;
                    end = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, 23:59:59`;
                    return [start, end];
                }
            } else {
                //transform for moment js
                let currFirstDate = this.currentDate.firstDate
                    .split(".")
                    .reverse()
                    .join(".");
                let currLastDate = this.currentDate.lastDate
                    .split(".")
                    .reverse()
                    .join(".");
                if (
                    moment(currFirstDate, "YYYY.MM.DD") <
                    moment(currLastDate, "YYYY.MM.DD")
                ) {

                    if (
                        this.showElements.showTime &&
                        this.currentDate.firstTime &&
                        this.currentDate.lastTime
                    ) {
                        start = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, ${this.transformTime(this.currentDate.firstTime)}`;
                        end = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, ${this.transformTime(this.currentDate.lastTime)}`;
                        return [start, end];
                    } else {
                        start = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, 00:00:00`;
                        end = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, 23:59:59`;
                        return [start, end];
                    }
                } else {
                    if (
                        this.showElements.showTime &&
                        this.currentDate.firstTime &&
                        this.currentDate.lastTime
                    ) {
                        start = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, ${this.transformTime(this.currentDate.firstTime)}`;
                        end = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, ${this.transformTime(this.currentDate.lastTime)}`;
                        return [start, end];
                    } else {
                        start = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, 00:00:00`;
                        end = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, 23:59:59`;
                        return [start, end];
                    }
                }
            }
        },

        /**
         * add new profile (profile management)
         * */
        addProfile(e) {
            if (this.$refs.addProfileForm.validate()) {
                this.disableSend = true;
                this.$axios
                    .post("http://core.memo.az/mainwindow/AddProfile", {
                        profileName: this.profilesManagement.addProfile,
                    })
                    .then((res) => {
                        this.showElements.showProfilePopUpAdd = false;
                        this.disableSend = false;
                        this.getProfiles();
                    })
                    .finally(() => {
                        this.profilesManagement.loading = false;
                    });
            }
        },
        /**
         * count figure of found articles
         * */
        countOfFoundArticles() {
            if (this.items[0]) {
                let arrOfCategories = this.items[0].children.childs;
                return arrOfCategories.reduce((acc, categ) => {
                    return acc + categ.newsCount;
                }, 0);
            }
            return 0;
        },
        /**
         * rename exist profile (profile management)
         * */
        renameProfile() {
            if (this.$refs.renameProfileForm.validate()) {
                this.disableSend = true;
                this.$axios
                    .post("http://core.memo.az/mainwindow/RenameProfile", {
                        oldName: this.profilesManagement.renameProfile.oldName,
                        newName: this.profilesManagement.renameProfile.newName,
                    })
                    .then((res) => {
                        this.showElements.showProfilePopUpRename = false;
                        this.disableSend = false;
                        this.getProfiles();
                    })
                    .finally(() => {
                        this.profilesManagement.loading = false;
                    });
            }
        },
        /**
         * remove profile (profile management)
         * */
        removeProfile() {
            if (
                this.profilesManagement.removeProfile === this.profiles.current
            ) {
                this.$toastr.warning(this.$t("messages.removeReject"));
                return;
            } else if (this.$refs.removeProfileForm.validate()) {
                this.disableSend = true;
                this.$axios
                    .post("http://core.memo.az/mainwindow/DeleteProfile", {
                        profileName: this.profilesManagement.removeProfile,
                    })
                    .then((res) => {
                        this.showElements.showProfilePopUpRemove = false;
                        this.disableSend = false;
                        //for prevent error on removing choosing profile settings
                        this.profilesManagement.radioGroup = this.profiles.list[0].name;
                    })
                    .then((res) => {
                        this.getProfiles();
                    })
                    .finally(() => {
                        this.profilesManagement.loading = false;
                    });
            }
        },
        /**
         * transform profile settings which came from server for treeview
         * */
        mapProfileSettingsNodes(items, i = 0) {
            return items.map((item, index) => ({
                ind: `${index}_${i}`,
                id: item.id,
                name: item.name,
                checked: item.checked,
                items: item.items
                    ? this.mapProfileSettingsNodes(
                          item.items,
                          `${index}_${i + 1}`
                      )
                    : [],
            }));
        },
        /**
         * filter checked treeview nodes
         * */
        filterCheckedProfileSettingsNodes(items) {
            return items.reduce((res, item) => {
                if (item.items.length === 0) {
                    if (item.checked === "true") {
                        return res.concat({
                            ind: item.ind,
                            id: item.id,
                            name: item.name,
                            checked: item.checked,
                        });
                    }
                } else {
                    if (item.checked !== "false") {
                        return res.concat(
                            this.filterCheckedProfileSettingsNodes(item.items)
                        );
                    }
                }
                return res;
            }, []);
        },
        /**
         * filter all treeview nodes
         * */
        filterAllProfileSettingsNodes(items) {
            return items.reduce((res, item) => {
                if (item.items.length === 0) {
                    return res.concat({
                        ind: item.ind,
                        id: item.id,
                        name: item.name,
                        checked: item.checked,
                    });
                } else {
                    return res.concat(
                        this.filterAllProfileSettingsNodes(item.items)
                    );
                }
            }, []);
        },
        /**
         * request which get profile settings
         * */
        getProfileSettings() {
            this.profilesManagement.loading = true;
            this.$axios
                .post("http://core.memo.az/mainwindow/GetProfile", {
                    profileName: this.profilesManagement.radioGroup,
                })
                .then((res) => {
                    this.formatKeyInObg(
                        res.data.sources,
                        "sourceType",
                        "items",
                        this.$t("tooltips.newsSources")
                    );
                    this.formatKeyInObg(
                        res.data.subjects.items,
                        "subjects",
                        "items",
                        this.$t("tooltips.newsCategory")
                    );
                    this.profilesManagement.profileSettings = res.data;
                    this.profilesManagement.selectionsSources = this.filterCheckedProfileSettingsNodes(
                        this.mapProfileSettingsNodes([
                            this.profilesManagement.profileSettings.sources,
                        ])
                    );
                    this.profilesManagement.selectionsSubject = this.filterCheckedProfileSettingsNodes(
                        this.mapProfileSettingsNodes([
                            this.profilesManagement.profileSettings.subjects.items,
                        ])
                    );
                })
                .finally(() => {
                    this.profilesManagement.loading = false;
                });
        },
        /**
         * transform data before new profile settings request
         * */
        transformProfileSettings() {
            let getAllId = (items) => {
                return items.reduce((res, item) => {
                    return res.concat(item.id);
                }, []);
            };
            let allSourcesNodes = this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.sources,
            ]);
            let allSubjectNodes = this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.subjects.items,
            ]);

            let allSourcesData = getAllId(
                this.filterAllProfileSettingsNodes(allSourcesNodes)
            );
            let allSubjectData = getAllId(
                this.filterAllProfileSettingsNodes(allSubjectNodes)
            );

            let sourcesData = getAllId(
                this.profilesManagement.selectionsSources
            );
            let subjectData = getAllId(
                this.profilesManagement.selectionsSubject
            );

            let uncheckedSources = allSourcesData.filter(function (id) {
                return !sourcesData.includes(id);
            });
            let uncheckedSubjects = allSubjectData.filter(function (id) {
                return !subjectData.includes(id);
            });
            return { sources: uncheckedSources, objects: uncheckedSubjects };
        },
        /**
         * request new profile settings
         * */
        setNewProfileSettings() {
            this.profilesManagement.loading = true;
            this.$axios
                .post("http://core.memo.az/mainwindow/SaveProfile", {
                    profileName: this.profilesManagement.radioGroup,
                    profile: this.transformProfileSettings(),
                })
                .then((res) => {
                    this.getProfiles();
                })
                .finally(() => {
                    this.profilesManagement.loading = false;
                });
        },
        /**
         * request which get profile list
         * */
         getProfiles() {
            this.$axios
                .post("http://core.memo.az/mainwindow/GetProfileNames", {})
                .then((res) => {
                    this.profiles.list = res.data;
                    if (res.data) {
                        this.profiles.current = res.data.filter((prof) =>
                            prof.types.includes(1)
                        )[0].name;
                    }
                })
                .then((res) => {
                    this.getInitialTree();
                })
                .finally(() => {});
                
        },
        /**
         * request which set active profile
         * */
        setProfile(e) {
            this.$store.commit("startLoader");
            let currProfile = this.profiles.list.filter(
                (profile) => profile.name === e
            )[0];
            this.$axios
                .post("http://core.memo.az/mainwindow/ActivateProfile", {
                    profileName: currProfile.name,
                    profileType: 1,
                })
                .then((res) => {
                    this.profiles.list = res.data;
                })
                .then((res) => {
                    this.profiles.current = currProfile.name;
                    this.getProfiles();
                })
                .finally(() => {
                    this.loaded = true;
                    this.$store.commit("stopLoader");
                });
        },
        /**
         * request which get data for main treeview
         * */
        getInitialTree() {
            let startDate = this.dateValidation()[0];
            let endDate = this.dateValidation()[1];
            let sendData = {
                startDate: startDate,
                endDate: endDate,
            };
            this.searchState = false;
            this.currNodeHash = "";
            this.$store.commit("startLoader");
            this.news = [];
            this.items = [];
            this.$axios
                .post(
                    "http://core.memo.az/mainwindow/getnewstreebydate",
                    sendData
                )
                .then((res) => {
                    this.items.push(res.data);
                    this.treeviewOpenedElements.push(
                        res.data,
                        res.data.children && res.data.children.childs[0]
                    );
                    this.$store.commit("stopLoader");
                })
                .then((res) => {
                    this.getArticles(this.items[0].children.childs);
                    if(this.$store.getters.openedElements.length){
                        this.treeviewOpenedElements2 = this.$store.getters.openedElements
                    } else{
                        this.treeviewOpenedElements2 = this.openTreeview(this.items[0].children.childs, 1)
                    }

                })
                .finally(() => {
                    this.loaded = true;
                });
        },
        /**
         * send search request after click on reload btn
         * */
        searchSubmit() {
            let searchValue = this.searchValue;
            let startDate = this.dateValidation()[0];
            let endDate = this.dateValidation()[1];
            this.currNodeHash = "";
            this.searchState = true;
            this.news = [];
            this.items = [];
            if (searchValue) {
                let sendData = {
                    query: searchValue,
                    startDate: startDate,
                    endDate: endDate,
                };
                this.$store.commit("startLoader");
                this.$axios
                    .post(
                        "http://core.memo.az/mainwindow/getnewstreebyquery",
                        sendData
                    )
                    .then((res) => {
                        if (res.data.childrenCount) {
                            this.items.push(res.data);
                            this.treeviewOpenedElements.push(
                                res.data,
                                res.data.children.childs[0]
                            );
                        }
                    })
                    .then((res) => {
                        if (this.items && this.items.length) {
                            this.getArticles(
                                [...this.items][0].children.childs
                            );
                        }
                    })
                    .then((res) => {
                        this.snackbarFoundArticles = true;
                        this.countOfFoundArticles();
                    })
                    .finally(() => {
                        this.loaded = true;
                        this.$store.commit("stopLoader");
                    });
            } else {
                this.getInitialTree();
            }
        },
        /**
         * send search request after click on reload btn
         * */
        getArticlesOnClick(event) {
            //mark active category
            let id = event.target.getAttribute("data-id");
            let allNodes = document.querySelectorAll(".v-treeview-node__root");
            [...allNodes].forEach((el) => el.classList.remove("is-active"));
            setTimeout(() => {
                let allDisabledNodes = document.querySelectorAll(
                    ".is-disabled"
                );
                [...allDisabledNodes].forEach((el) =>
                    el.classList.remove("is-disabled")
                );
            }, 0);
            let activeNode = event.target
                .closest(".v-treeview-node")
                .querySelector(".v-treeview-node__root");
            activeNode.classList.add("is-active");

            //get article on click
            if (id !== this.currNodeHash) {
                this.$store.dispatch('setCurrNodeHash', id)
                this.getArticles([{ hashCode: id }]);
            }
        },
        /**
         * request which get articles list for v-data-table
         * */
        getArticles(obj) {
            //reset pagination between requests
            this.pagination.current = 0;
            let category = obj[0];
            if (category === undefined || category.hashCode == 0) {
                return;
            }
            if (category.hashCode == this.currNodeHash) {
                return;
            }
            this.selectedArticlesContent = "";
            this.currNodeHash = this.$store.getters.nodeHash ? this.$store.getters.nodeHash : category.hashCode;
            let sendData = {
                nodeHash: this.currNodeHash,
                startIndex: "0",
                endIndex: "999",
                searchActivated: "false",
            };
            this.page = 1;
            this.pageCount = Math.ceil(category.newsCount / 12);
            this.$store.commit("startLoader");
            this.loading = true;
            this.$axios
                .post(
                    " http://core.memo.az/mainwindow/GetNewsListByTreeNode",
                    sendData
                )
                .then((res) => {
                    this.news = res.data.news;
                    this.news &&
                        this.news.forEach((article, index) => {
                            let formatedDate = new Date(
                                article.publishDate
                            ).toLocaleDateString("ru-RU", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                            });
                            this.news[index].publishDate = formatedDate;
                        });
                })
                .then((res) => {
                    let selectorOfactiveNode = `[data-id='${this.currNodeHash}']`;
                    if (document.querySelector(selectorOfactiveNode)) {
                        let activeNode = document
                            .querySelector(selectorOfactiveNode)
                            .closest(".v-treeview-node")
                            .querySelector(".v-treeview-node__root");
                        let allNodes = document.querySelectorAll(
                            ".v-treeview-node__root"
                        );
                        [...allNodes].forEach((el) =>
                            el.classList.remove("is-active")
                        );
                        activeNode.classList.add("is-active");
                    }
                })
                .finally(() => {
                    this.loaded = true;
                    this.loading = false;
                    this.$store.commit("stopLoader");
                });
        },
        /**
         * divide text for properly highlight on search and category selections
         * */
        divideText(text, title) {
            if (!text) {
                return;
            }
            let res = [];
            let innerText = text;
            let innerTitle = title;
            this.selectionsRange = [];

            //put in selectionsRange search and categories ranges with including type key
            if (
                this.selections.search.length !== 0 &&
                this.selections.categories.selection
            ) {
                this.selections.search.forEach((s) => {
                    s.type = "search";
                    this.selectionsRange.push(s);
                });
                this.selections.categories.selection.forEach((s) => {
                    s.type = "category";
                    this.selectionsRange.push(s);
                });
            } else if (
                this.selections.search.length === 0 &&
                this.selections.categories.selection
            ) {
                this.selections.categories.selection.forEach((s) => {
                    s.type = "category";
                    this.selectionsRange.push(s);
                });
            } else if (
                this.selections.search.length !== 0 &&
                !this.selections.categories.selection
            ) {
                this.selections.search.forEach((s) => {
                    s.type = "search";
                    this.selectionsRange.push(s);
                });
            }

            if (this.selectionsRange.length !== 0) {
                let ranges = this.selectionsRange;
                let selectText = ranges.reduce((accum, range) => {
                    let { start, length, type } = range;
                    let markedText = {};
                    markedText.type = type;
                    if (type === "search") {
                        if (title.length > +start) {
                            markedText.text = title.substring(
                                +start,
                                +start + +length
                            );
                        } else {
                            markedText.text = text.substring(
                                +start - (title.length + 1),
                                +start - (title.length + 1) + +length
                            );
                        }
                    } else {
                        if (title.length > +start) {
                            markedText.text = title.substring(
                                +start,
                                +start + +length
                            );
                        } else {
                            markedText.text = text.substring(
                                +start - (title.length + 1),
                                +start - (title.length + 1) + +length
                            );
                        }
                    }
                    return accum.concat(markedText);
                }, []);

                selectText.forEach((selection) => {
                    if (selection.type === "category") {
                        if (innerTitle.includes(selection.text)) {
                            innerTitle = innerTitle.replace(
                                selection.text,
                                `<mark style="color: #fff; background: #1976d2;">${selection.text}</mark>`
                            );
                        } else {
                            innerText = innerText.replace(
                                selection.text,
                                `<mark style="color: #fff; background: #1976d2;">${selection.text}</mark>`
                            );
                        }
                    }
                });
                selectText.forEach((selection) => {
                    if (selection.type === "search" && selection.text !== "") {
                        innerTitle = innerTitle.replaceAll(
                            selection.text,
                            `<mark style="color: #4e4e4e; background: #ffdc91;">${selection.text}</mark>`
                        );
                        innerText = innerText.replaceAll(
                            selection.text,
                            `<mark style="color: #4e4e4e; background: #ffdc91;">${selection.text}</mark>`
                        );
                    }
                });
            }
            innerText.split("\r").forEach((p) => {
                res.push(`${p}</br>`);
            });
            this.formated.title = innerTitle;
            this.formated.text = res.join("");
            return;
        },
        /**
         * close all articles
         * */
        closeArticle() {
            this.tableExpandedItem = [];
            this.tableExpandedItem.isOpen = null;
            this.selectedArticlesContent = "";
            this.currArticleId = "";
        },
        /**
         * request which get sigle article on v-data-table row extention
         * */
        getSingleArticle(e) {
            if (this.tableExpandedItem.isOpen === e.id) {
                this.tableExpandedItem = [];
                this.tableExpandedItem.isOpen = null;
                this.selectedArticlesContent = "";
                this.currArticleId = "";
                return;
            }
            this.$store.commit("startLoader");
            this.loading = true;
            this.selectedArticlesContent = "";
            this.currArticleId = e.id;
            let sendData = {
                nodeHash: this.currNodeHash,
                id: e.id,
                searchActivated: this.searchState,
            };
            this.$axios
                .post(
                    "http://core.memo.az/mainwindow/getsinglenewsbyhashandid",
                    sendData
                )
                .then((res) => {
                    this.loading = false;
                    this.$store.commit("stopLoader");
                    this.selections.categories = "";
                    this.selections.search = "";
                    this.formated.id = res.data.id;
                    this.selectedArticlesContent = res.data;
                    if (res.data.querySelections) {
                        this.selections.search =
                            res.data.querySelections.querySelection;
                    }
                    this.tableExpandedItem.data = [res.data];
                    this.tableExpandedItem.isOpen = e.id;
                    this.selections.categories =
                        res.data.subjects.subject[0].selections;
                    if (res.data.subjects) {
                        this.currCategorySelect =
                            res.data.subjects.subject[0].name;
                    }
                })
                .finally(() => (this.loaded = true));
        },
        closeDatePicker() {
            this.showElements.showDate = false;
        },
        getCategorySelections(name) {
            this.loading = true;
            let sendData = {
                nodeHash: this.currNodeHash,
                id: this.currArticleId,
                subject: name,
            };
            this.$axios
                .post(
                    "http://core.memo.az/mainwindow/GetNewsSelectionsBySubject",
                    sendData
                )
                .then((res) => {
                    this.loading = false;
                    this.selections.categories = res.data;
                })
                .finally(() => (this.loaded = true));
        },
        /**
         * open Topics popup
         * */
        openTopics(data) {
            this.activeTopics = data;
            this.showElements.showTopicsPupUp = true;
        },
    },
    beforeDestroy(){
                this.$store.dispatch('setCurrNodeHash', this.currNodeHash)
                this.$store.dispatch('setOpenedElements', this.treeviewOpenedElements2)
    }
};
</script>
<style lang="scss">
.reportsSelect {
    max-width: 245px;
    margin: 0 5px;
    height: 34px;
    .v-input__slot {
        margin-bottom: 0;
        padding: 0 5px;
    }
}
.news-reports > div {
    padding: 0;
}
.title_td {
    min-width: 300px;
}

.treeview__main .v-treeview-node__level {
    width: 12px;
}

.treeview__main-scroll {
    @media (max-width: 1280px) {
        height: calc(100vh - 175px) !important;
    }
}

.expansion-is-open {
    .treeview__main-scroll {
        @media (max-width: 1280px) {
            height: calc(100vh - 260px) !important;
        }
    }
}

.news__list tr {
    cursor: pointer;
}

.news__list th span {
    white-space: nowrap;
}

.vuetify__select {
    max-width: 260px;
}

.v-data-table__expand-icon {
    pointer-events: none;
}

.v-treeview-node__label {
    font-size: 12px !important;
    white-space: pre-wrap !important;
}

.fill-width {
    width: 100%;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0 8px !important;
}
.v-data-table-header {
    th {
        padding: 0 8px !important;
    }
    & th:nth-child(3) {
        min-width: 85px !important;
    }

    & th:nth-child(4) {
        min-width: 300px;
    }

    & th:nth-child(5) {
        min-width: 120px;
    }

    & th:nth-child(6) {
        min-width: 200px;
    }

    & th:nth-child(7) {
        min-width: 140px;
    }
}

[aria-expanded="true"] > .v-treeview-node__root {
    background: #f3f3f3;
    filter: grayscale(100%);
}

.is-disabled {
    filter: grayscale(0) !important;
}

.is-active {
    background: #ffdc91 !important;
    filter: grayscale(0) !important;
}

.v-treeview-node--leaf .is-active {
    pointer-events: none;
}

.v-card__text a {
    word-break: break-all;
}

.v-card__title {
    word-break: normal;
}

.treeview__activator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.v-treeview-node__label span {
    color: rgba(0, 0, 0, 0.87) !important;
}

.v-menu__content {
    background: #fff;
}

.article__title {
    & a {
        text-decoration: none;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 0.7;
        }
    }
}

.v-data-table__mobile-row {
    min-width: 90vw;
    max-width: 90vw !important;
}

.v-sheet.v-snack__wrapper:not(.v-sheet--outlined) {
    max-width: max-content;
    min-width: 200px;
}

@media (max-width: 767px) {
    .v-data-table__expanded td {
        max-width: 90vw !important;
    }
    .v-data-table__wrapper {
        max-width: 90vw !important;
    }
    .v-data-table__mobile-table-row {
        display: block !important;
    }

    .v-data-table__wrapper tbody {
        display: flex !important;
        flex-direction: column !important;
    }
}

.v-card__text img {
    max-width: 20%;
}

.input-date {
    max-width: 170px;
}

.input-date .v-icon,
.lastTime .v-icon {
    font-size: 14px;
}

//component styles

.select--lang {
    text-transform: uppercase;
    max-width: 50px;
}

.profile {
    &__card {
        overflow: hidden;

        &-title {
            color: #757575;
            border-bottom: 1px solid #e8e8e8;
        }
    }
}

.scroll-area {
    position: relative;
    margin: auto;
    height: 195px;
}

.search_input {
    max-width: 200px;
    @media (max-width: 1500px) {
        max-width: 150px;
    }
}

.ps__thumb-x,
.ps__thumb-y {
    background-color: #2196f3;
}

.ps__rail-y.ps--clicking .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y:hover > .ps__thumb-y {
    background-color: #2196f3;
}

/*.lastTime, .firstTime{
  filter: brightness(0) invert(1);
}*/

/*margins*/

@media (max-width: 1500px) {
    .v-application .ml-3 {
        margin-left: 8px !important;
    }
    .v-application .mr-3 {
        margin-right: 8px !important;
    }
}

/*appearance on different sizes*/

.select--lang {
    & .v-select__selections {
        max-width: min-content;
    }

    & .v-input__append-inner {
        margin: 0 !important;
        padding: 0 !important;
    }
}

.profiles__btns {
    & .v-toolbar__content {
        @media (max-width: 1359px) {
            width: 100%;
        }
    }
}

.popup__card {
    @media (max-width: 480px) {
        min-width: 100%;
    }
}

.search_input ~ button i:before {
    color: #ffdc91;
}

//transition

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.drawer__header {
    .btn--stroke {
        border-color: #2196f3;
    }
    .v-input__slot {
        &::before {
            border-color: #2196f3 !important;
        }
    }
    .v-select__selection {
        color: #2196f3 !important;
    }
    .v-select__slot {
        label {
            color: #2196f3;
        }
    }
    .v-icon {
        svg {
            fill: #2196f3;
        }
    }
}

.profile {
    form {
        background: #fff;
    }
    .v-input--selection-controls__input {
        display: none;
    }
    .v-radio {
        &.v-item--active,
        &:hover {
            background: #e3f3ff;
        }
    }
}

.settings-expand {
    .v-expansion-panel-header {
        padding: 0;
        min-height: unset !important;
    }
    .v-expansion-panel-header__icon {
        margin: 0 auto;
    }
    .v-expansion-panel-content__wrap {
        padding: 0;
    }
    .v-expansion-panel-header .v-icon {
        position: relative;
        font-size: 0 !important;
        height: 20px;
        &::before {
            content: "";
            border-top: 7px solid #2196f3;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
        }
    }
}

.article__closer {
    display: flex;
    justify-content: flex-end;
    margin-top: -50px;
    &-btn {
        position: relative;
        margin-right: -14px;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        transition: all 0.2s ease;
        outline: none;
        &:hover {
            background: #2196f3;
        }
        &::before {
            position: absolute;
            content: "";
            top: 50%;
            left: 50%;
            width: 9px;
            height: 9px;
            border-bottom: 2px solid rgba(0, 0, 0, 0.54);
            border-left: 2px solid rgba(0, 0, 0, 0.54);
            transform: translate(-50%, -50%) rotate(135deg);
        }
    }
}
.topics-btn {
    margin: 0 auto;
    svg {
        fill: #757575;
        stroke: #757575;
    }
    &:hover {
        fill: rgb(33, 150, 243);
        stroke: rgb(33, 150, 243);
    }
}

.user-settings-popup {
    @media (max-width: 767px) {
        .v-data-table__wrapper,
        .v-data-table__expanded td,
        .v-data-table__mobile-row {
            max-width: 100vw !important;
        }
        .v-data-table-header-mobile__wrapper .v-select {
            max-width: 65%;
        }
    }
}

.v-data-table-header th[style="width: 110px; min-width: 110px;"] {
    white-space: nowrap;
}
</style>
